<template>
  <!-- <router-link to="/">Home</router-link> |
  <router-link to="/about">About</router-link> -->
  <a-config-provider :locale="zhCN">
    <router-view />
  </a-config-provider>
</template>
<script setup>
import zhCN from "ant-design-vue/es/locale/zh_CN";//全局设置ant框架语言为中文
import { ref } from "vue";
import { admingetRegion } from '@/api/api.js'
const option = ref([])
const area = localStorage.getItem('region') ? JSON.parse(localStorage.getItem('region')) : ''
if (!area) {
  admingetRegion().then(res => {
    option.value = []
    res.data.data.forEach(element => {
      option.value.push({
        value: element.region_id,
        label: element.region_name
      })
    });
    localStorage.setItem('region', (JSON.stringify(option.value)))
  }).catch(() => {
  })
}
console.log(area);

</script>
<style lang="scss">
#app {
  font-family: PingFangSC-Medium, PingFang SC, 思源黑体;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

@media screen and (max-width: 1360px) {

  // 限制适应rem的最小宽度为1200px
  html {
    font-size: 134.3px !important;
    min-width: 1360px;
  }
}

html,
body,
#app {
  height: 100%;
}

body {
  margin: 0;
  padding: 0;
  // font-size: 14px;
}

/* 自定义滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 8px;
  background-color: #F9F9F9;
}

::-webkit-scrollbar-thumb {
  background-color: #0060FA;
  /* 滚动条拖动块颜色 */
  border-radius: 4px;
  /* 滚动条拖动块圆角 */
}

::-webkit-scrollbar-track {
  background-color: #F9F9F9;
  /* 滚动条轨道颜色 */
  border-radius: 4.5px;
  /* 滚动条轨道圆角 */
}
</style>
